import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ConnectedAppsContentContainer, SpinnerContainer } from './styles'
import { useAppSelector } from 'app/hooks'
import { Spinner } from 'components/Loader'
import {
  connectedAppsListSelector,
  connectedAppsListIsLoading,
} from 'features/home/selectors'
import ConnectedAppsList from './components/ConnectedAppsList'
import { PartnerShape } from './types'
import { SectionLabel } from 'components/Typography'
import { connectedAppsMessages } from './messages'

const ConnectedApps: FC = () => {
  const isLoading = useAppSelector<boolean>(connectedAppsListIsLoading)
  const connectedApps = useAppSelector<PartnerShape[]>(
    connectedAppsListSelector
  )
  return (
    <>
      <ConnectedAppsContentContainer>
        <SectionLabel>
          <FormattedMessage {...connectedAppsMessages.title} />
        </SectionLabel>
        {!isLoading ? (
          <ConnectedAppsList connectedApps={connectedApps} />
        ) : (
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        )}
      </ConnectedAppsContentContainer>
    </>
  )
}

export default ConnectedApps
